export function setStatusBarBackgroundColor() {}
export function setStatusBarNetworkActivityIndicatorVisible() {}
export function setStatusBarHidden() {}
export function setStatusBarStyle() {}
export function setStatusBarTranslucent() {}
export function StatusBar() {
  return null;
}
